/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import { columnCode } from '../../enums/columnCodeEnumsVehicle';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import CommonCreationErrorsApp from "./Functionality/CommonCreationErrorsApp";
import {MODELS} from "../../Apis/Models";
import routes from "../../Routes/routes";
import {permissionObj} from "../../Helpers/permission";
import HeadTittle from "../../components/HeadTittle";
import ButtonAction from "../../components/buttons/ButtonAction";
import DivContainerBody from "../../components/DivContainerBody";
import CreationErrorsBody from "./SubComponents/CreationErrorsBody";
import CreationErrorsVehicleApp from "./Functionality/CreationErrorsVehicleApp";

const CreationErrorsVehicle = () => {
    const props = CommonCreationErrorsApp({
        moduleId: MODELS.vehicle,
        goBack:routes.vehicleFleet.list,
        columns:new Array(7).fill({ type: 'text', width: 130 })
    });
    const {t, DEV, permission, navigate, errorsArray, jRef, totalErrors, selectedErrorIndex} = props;
    const {handleConfirm, handleUploadFile} = CreationErrorsVehicleApp(props);

    if(!DEV && (!permission?.includes(permissionObj.WEB_VEHICLE_READ))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={t('import')} link={routes.vehicleFleet.list}>
                {totalErrors === 0 ? (
                    <ButtonAction
                        id='btn_cev_import'
                        name='import'
                        className='btn-icon-accent-450'
                        onClick={handleConfirm}
                    />
                ) : (
                    <ButtonAction
                        id='btn_cev_verify'
                        name='verify'
                        className='btn-icon-accent-450'
                        onClick={handleUploadFile}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <CreationErrorsBody
                    mainJRef={{name:t('excel'), jRef:jRef}}
                    totalErrors={totalErrors}
                    errorsArray={errorsArray}
                    selectedErrorIndex={selectedErrorIndex}
                    columnCode={columnCode}
                />
            </DivContainerBody>
        </>
    );
};

export default CreationErrorsVehicle;
